const patterns = {
  fullName: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  companyName: /^[a-zA-Z0-9\s.-]+$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/,
  // phoneNumber: /^[1-9]\d{9}$/,
  phoneNumber:
    /^(\+?1\s?\d{10}|\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}|[6-9]\d{9})$/,
};

export const isValid = (type: keyof typeof patterns, value: string) => {
  if (!value.trim()) return false;
  return patterns[type].test(value.trim());
};
